import { ServerFetch } from '../main-model'

export default class ProductGroupSacleModel extends ServerFetch {
    getProductGroupScaleBy = (data) => this.authFetch({
        url: 'product-group-scale/getProductGroupScaleBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}